import { createRoot } from 'react-dom/client';

// styles
import 'assets/style.css';
import 'simplebar-react/dist/simplebar.min.css';
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

// fonts
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import { AuthProvider } from 'pages/AuthProvider';
import { ConfigProvider } from 'contexts/ConfigContext';
import ThemeCustomization from 'themes'; // 🔥 THIS WAS MISSING
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <ThemeCustomization>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeCustomization>
  </ConfigProvider>
);

reportWebVitals();
